import DateModificationTopology from "../../pages/treatments/DataModificationTopology";

interface ITextRight {
  element: any;
  type: string;
}

const TextRight = ({type,element}:ITextRight) => {
  switch (type) {
    case "topologies":
      return <DateModificationTopology topology={element} />;
    default:
      return <></>;
  }
};

export default TextRight;
